import { useQuery } from "@tanstack/react-query";
import { apiGet, UnauthenticatedError } from "@/lib/apiClient";
import type { AuthenticatedUser } from "@shared/types/user";

export function useAuth() {
  return useQuery({
    queryKey: ["auth", "me"],
    queryFn: async () => {
      try {
        return await apiGet<AuthenticatedUser>("/api/auth/me");
      } catch (err) {
        if (err instanceof UnauthenticatedError) return null;
        throw err;
      }
    },
    staleTime: 60_000,
  });
}
